"use client";

import Header from "../components/header/header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";
import { GoHome } from "react-icons/go";
import { IoMdSearch, IoMdCloseCircle, IoMdClose } from "react-icons/io";
import BlogTile from "../components/BlogTile/blogTile";

import urlList from "@/urlList";
import axios from "axios";
import { useState, useRef, useEffect } from "react";
import Link from "next/link";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useRouter } from "next/navigation";

import "./homePage.css";

function HomePage({blogs, allCategory, selectedAowId, isErrorPage, showPartner}:any) {
  const [showChip, setShowChip] = useState(false);
  const [chipData, setChipData] = useState("");
  const [searchData, setSearchData] = useState("");
  const [blogData, setBlogData] = useState<any>([]);
  const [maxPage, setMaxPage] = useState(0);
  const [aowId, setAowId] = useState<any>(null);
  const aowIdRef = useRef(aowId);
  const loaderArr = Array(9).fill(null);
  const [selectedAow, setSelectedAow] = useState(0);
  const [blogStatus, setblogStatus] = useState(false);
  const [searchMenuData, setSearchMenuData] = useState<any>([]);
  const blogBoxRef = useRef(null);
  const [searchToggleForAow, setSearchToggleForAow] = useState(false);

  const [lastScrollY, setLastScrollY] = useState(0);
  let [page, setPage] = useState(0);
  const [delay, setDelay] = useState(true);

  const router = useRouter();

  const getAllBlogs = () => {
      setBlogData(blogs);
      setDelay(true);
        setPage(page + 1);
        setblogStatus(true);
  };

  useEffect(() => {
    aowIdRef.current = aowId;
  }, [aowId]);

  const searchMenu = (value: any) => {
    setSearchData(value);
    if (value === "") {
      setSearchMenuData([]);
      return;
    }

    axios
      .get(urlList.GET_GLOBAL_SEARCH_BLOG, {
        params: {
          keyword: value,
        },
      })
      .then((res: any) => {
        setSearchMenuData(res.data.data);
      });
  };

  const search = () => {
    if (searchData != "") {
      axios
        .get(urlList.GET_GLOBAL_SEARCH_BLOG, {
          params: {
            keyword: searchData,
          },
        })
        .then((res: any) => {
          if (res.data.isSuccess) {
            setBlogData(res.data.data);
            setblogStatus(true);
          } else {
            setBlogData([]);
            setblogStatus(true);
          }
          setSearchToggleForAow(true);
        });
      setBlogData([]);
      setblogStatus(false);
      setSelectedAow(-1);
      setShowChip(true);
      setChipData(searchData);
      setSearchData("");
      setPage(0);
    }
  };

 
  useEffect(() => {
    getAllBlogs();
  }, [aowId]);

  return (
    <>
    <div className="min-h-screen">
      <Header showPartner={showPartner} />
      <div className="w-[92vw] mx-auto mb-4 flex gap-4 flex-col homeMargin">
        {!isErrorPage && (
        <div className="flex gap-[0.3rem]">
          <Link className="blogCard flex items-center" href={`/`}>
            <div className="flex items-center">
              <GoHome className=" homeClass" />
            </div>
          </Link>
          <div className="flex items-center">
            <FontAwesomeIcon
              icon={faAnglesRight}
              className="angleRight text-[#626568]"
            />
          </div>
          <Link className="blogCard flex items-center" href={`/insights`}>
            <div className=" breadInsight font-bold text-[#2A2C2E] flex items-center">
              Insights
            </div>
          </Link>
        </div>
        )}

        <div className="flex flex-col items-center sm:flex-row sm:justify-between sm:items-center">
          {!isErrorPage ? <div className="text-2xl font-bold text-[#161718] ">All Insights</div> :<div className="text-2xl font-bold text-[#161718] ">Other Insights</div>}
          <div className="flex justify-between gap-2 relative">
            <div className="w-[70vw] sm:w-[40vw] flex items-center border-2 border-gray-200 pr-2 rounded-md ">
              <input
                className="w-[100%]  px-3 py-1 outline-none rounded-l-md text-sm"
                type="text"
                placeholder="Search"
                value={searchData}
                onChange={(event: any) => searchMenu(event.target.value)}
              />
              {!searchData ? (
                <div className="px-3 py-1 rounded-r-md text-gray-500">
                  <IoMdSearch />
                </div>
              ) : (
                <div className=" px-3 py-1 rounded-r-md text-gray-500">
                  <IoMdClose
                    className="cursor-pointer  hover:text-gray-700"
                    onClick={() => {
                      setSearchData("");
                      setSearchMenuData([]);
                    }}
                  />
                </div>
              )}
            </div>

            <div
              className="cursor-pointer bg-[#007BC5] text-center font-bold text-white text-sm py-2 px-4 rounded-md w-[7rem] [@media(max-width:430px)]:w-[5rem]"
              onClick={search}
            >
              Search
            </div>

            {searchData != "" ? (
              <div className="w-[40vw] max-h-[25rem] overflow-scroll bg-white overflow-x-hidden absolute top-[2.5rem] left-0 z-50 searchMenu">
                {searchMenuData &&
                  searchMenuData?.map((item: any, index: any) => {
                    return (
                      <Link
                        href={`/insights/${item.url.replaceAll(" ","-").replace(/ |\u00A0|%C2%A0/g,'-')}`}
                        key={index}
                        className="w-full block py-[0.5rem] text-[#000000e1] hover:bg-slate-200 cursor-pointer px-4 text-xs font-bold"
                      >
                        {item.title}
                      </Link>
                    );
                  })}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>

        <div className="bg-[#F1F6F9] rounded-md p-3 flex flex-wrap gap-3 my-[1rem] min-h-[20px] chipScoller">
          <div 
            className={` text-sm px-3 py-1 border-[1px] border-[#007BC5] rounded-2xl cursor-pointer  transition-transform duration-300 ease-in-out flex-shrink-0 ${
              !searchToggleForAow && selectedAowId === null
                ? "bg-[#007BC5] text-white"
                : "text-[#007BC5] bg-white hover:bg-cyan-100"
            }`}
            // onClick={allBlogs}
            onClick={() => {
              setSearchToggleForAow(false);
              setShowChip(false);
              setChipData("");
              setBlogData(blogs)
              router.push("/insights"); 
            }}
          >
            All
          </div>
          {allCategory?.length != 0
            ? allCategory?.map((item: any, index:any) => {
                return (
                  <div 
                    className={` text-sm px-3 py-1 border-[1px] border-[#007BC5] rounded-2xl cursor-pointer  transition-transform duration-300 ease-in-out flex-shrink-0 ${
                      !searchToggleForAow && selectedAowId == item.areaId
                        ? "bg-[#007BC5] text-white"
                        : "text-[#007BC5] bg-white hover:bg-cyan-100"
                    }`}
                    key={index}
                    // onClick={() => {
                    //   categoryCall(item);
                    // }}
                    onClick={() => {
                      setSearchToggleForAow(false);
                      setShowChip(false);
                      setChipData("");
                      router.push(`/insights/aow/${item.displayAreaName.replace(/[\/ ]/g, '-') 
                        .replace(/-+/g, '-') 
                        .replace(/^-|-$/g, '')}/${item.areaId}`); 
                      setBlogData(blogs)
                    }}
                  >
                    {item.displayAreaName}
                  </div>
                );
              })
            : Array(12)
                .fill(null)
                .map((_, index) => (
                  <div className="" key={index} style={{ marginBottom: "6px" }}>
                    <Skeleton
                      width={120}
                      height={22}
                      style={{ borderRadius: "8px" }}
                    />
                  </div>
                ))}
        </div>

        {showChip ? (
          <div className="flex flex-wrap gap-3 mt-[1rem] ">
            <div className="flex gap-1 items-center  px-3 py-2  bg-[#DBE9F6] rounded-2xl">
              <div className="text-[#007BC5] text-xs">{chipData}</div>
              <IoMdCloseCircle
                className="text-[#007BC5] cursor-pointer"
                onClick={() => {
                  setSearchToggleForAow(false);
                  setBlogData(blogs)
                  // setblogStatus(false);
                  // setSelectedAow(0);
                  // setAowId(null);
                  // setBlogData([]);
                  setShowChip(false);
                  setChipData("");
                  // blogData.length = 0;
                  // getAllBlogs();
                }}
              />
            </div>
          </div>
        ) : (
          ""
        )}

        <div
          ref={blogBoxRef}
          className={`flex flex-wrap gap-[1.5vw] ${blogStatus && blogData.length === 0 ? "" : 'blogBox'} `}
          id="third-div"
        >
          {blogStatus && blogData.length > 0 ? (
            blogData.map((item: any, i: any) => (
              <div key={i} className="min-w-[300px] min-h-[350px]">
                <BlogTile
                  id={item.id}
                  title={item.title}
                  blogImage={item.blogImage}
                  desc={item.description}
                  tags={item.tags}
                  date={item.publishDate}
                  aow={item.areaOfWork}
                  tech={item.technlogy}
                  url={item.url}
                  index={i}
                  isAiGenerated={item.isAiGenerated}
                />
              </div>
            ))
          ) : blogStatus && blogData.length === 0 ? (
            <div className="w-full h-full flex items-center justify-center">
              <div className="text-red-500 font-bold text-center py-4">
                No Data Found!
              </div>
            </div>
          ) : (
            loaderArr.map((_, index) => (
              <div key={index} className="min-w-[300px] min-h-[350px]">
                <Skeleton className="skeleton-box1" />
                <Skeleton className="skeleton-box" />
                <Skeleton className="skeleton-box2" />
                <Skeleton className="skeleton-box3" />
                <Skeleton className="skeleton-box4" />
                <Skeleton className="skeleton-box5" />
              </div>
            ))
          )}
          {!delay ? (
          <div className="flex flex-wrap gap-[1.5vw] justify-center" id="third-div">
            {Array.from({ length: 9 }).map((_, index) => (
              <div key={index} className="min-w-[300px] min-h-[350px]">
              <Skeleton className="skeleton-box1" />
              <Skeleton className="skeleton-box" />
              <Skeleton className="skeleton-box2" />
              <Skeleton className="skeleton-box3" />
              <Skeleton className="skeleton-box4" />
              <Skeleton className="skeleton-box5" />
            </div>
            ))}
          </div>
        ) : (
          ""
        )}
        </div>
        </div>
      </div>
    </>
  );
}

export default HomePage;
